import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

const ViewUser = () => {
  const { username } = useParams();
  const [activeSection, setActiveSection] = useState("transactions");
  const [balance, setBalance] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [showExchangeModal, setShowExchangeModal] = useState(false);
  const [exchangeTab, setExchangeTab] = useState("deposit");
  const [depositAmount, setDepositAmount] = useState("");
  const [depositDescription, setDepositDescription] = useState("");
  const [packages, setPackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState("");
  const [userPackages, setUserPackages] = useState([]);

  const staffData = JSON.parse(localStorage.getItem("staffData"));
  const staffUsername = staffData?.username || "unknown";

  useEffect(() => {
    fetchBalance();
    fetchTransactions();
    fetchPackages();
    fetchUserPackages();
  }, [username]);

  useEffect(() => {
    if (activeSection === "plan") {
      fetchUserPackages(); // ambil ulang data saat tab Plans aktif
    }
  }, [activeSection]);

  const fetchBalance = async () => {
    try {
      const res = await fetch(`https://api.backofficemain.com/get_balance.php?username=${username}`);
      const data = await res.json();
      if (data.success) setBalance(parseFloat(data.balance));
      else setBalance(0);
    } catch (err) {
      console.error("Error fetching balance:", err);
    }
  };

  const fetchUserPackages = async () => {
  try {
    const res = await fetch(`https://api.backofficemain.com/get_user_packages.php?username=${username}`);
    const data = await res.json();
    if (data.success && Array.isArray(data.data)) {
      setUserPackages(data.data);
    } else {
      setUserPackages([]);
    }
  } catch (err) {
    console.error("Error fetching user packages:", err);
    setUserPackages([]);
  }
};


  const fetchTransactions = async () => {
    try {
      const [depositRes, withdrawRes, bonusRes] = await Promise.all([
        fetch(`https://api.backofficemain.com/get_deposits.php?username=${username}`),
        fetch(`https://api.backofficemain.com/get_withdraws.php?username=${username}`),
        fetch(`https://api.backofficemain.com/get_bonus.php?username=${username}`)
      ]);

      const depositData = await depositRes.json();
      const withdrawData = await withdrawRes.json();
      const bonusData = await bonusRes.json();

      const deposits = depositData.data?.map((item) => ({
        id: `D${item.id}`,
        type: "Deposit Funds",
        category: "Deposit",
        amount: `+$${parseFloat(item.nominal).toFixed(2)}`,
        status: "Approved",
        date: item.created_at,
      })) || [];

      const withdraws = withdrawData.data?.map((item) => ({
        id: `W${item.id}`,
        type: "Withdrawal Funds",
        category: "Withdrawal",
        amount: `-$${parseFloat(item.amount).toFixed(2)}`,
        status: item.is_approved === 1 ? "Approved" : "Pending",
        date: item.created_at,
      })) || [];

      const bonuses = bonusData.data?.map((item) => ({
        id: `B${item.id}`,
        type: "Bonus",
        category: "Bonus",
        amount: `+$${parseFloat(item.nominal).toFixed(2)}`,
        status: "Approved",
        date: item.created_at,
      })) || [];

      const all = [...deposits, ...withdraws, ...bonuses].sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      );
      setTransactions(all);
    } catch (err) {
      console.error("Error fetching transactions:", err);
    }
  };

  const fetchPackages = async () => {
    try {
      const res = await fetch("https://api.backofficemain.com/get_package_for_buy.php");
      const data = await res.json();
      if (data.success) setPackages(data.data);
    } catch (err) {
      console.error("Error fetching packages:", err);
    }
  };

  const handleBuyPackage = async () => {
    if (!selectedPackage) {
      alert("Pilih package terlebih dahulu!");
      return;
    }

    const pkg = packages.find((p) => p.id === parseInt(selectedPackage));
    if (!pkg) {
      alert("Package tidak ditemukan!");
      return;
    }

    if (balance < parseFloat(pkg.price)) {
      alert("Saldo tidak cukup!");
      return;
    }

    try {
      const response = await fetch("https://api.backofficemain.com/add_package_transaction.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_username: username,
          package_id: pkg.id,
          price: pkg.price,
        }),
      });

      const data = await response.json();
      if (data.success) {
        alert("Package berhasil dibeli!");
        setSelectedPackage("");
        fetchBalance();
        fetchUserPackages();
      } else {
        alert("Gagal membeli package!");
      }
    } catch (err) {
      console.error("Error buying package:", err);
    }
  };

  const handleConfirm = async () => {
    if (!depositAmount || Number(depositAmount) <= 0) {
      alert("Please enter a valid amount!");
      return;
    }

    try {
      let apiUrl = "";
      const formData = new FormData();
      formData.append("user_username", username);
      formData.append("staff_username", staffUsername);

      if (exchangeTab === "deposit") {
        apiUrl = "https://api.backofficemain.com/add_deposit.php";
        formData.append("nominal", depositAmount);
        formData.append("description", depositDescription);
      } else if (exchangeTab === "withdraw") {
        apiUrl = "https://api.backofficemain.com/add_withdraw.php";
        formData.append("amount", depositAmount);
      } else if (exchangeTab === "bonus") {
        apiUrl = "https://api.backofficemain.com/add_bonus.php";
        formData.append("nominal", depositAmount);
        formData.append("description", depositDescription);
      }

      const res = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const result = await res.json();

      if (result.success) {
        alert(
          exchangeTab === "bonus"
            ? "Bonus successfully added!"
            : exchangeTab === "deposit"
              ? "Deposit successfully added!"
              : "Withdrawal request recorded successfully!"
        );
        setDepositAmount("");
        setDepositDescription("");
        setShowExchangeModal(false);
        fetchBalance();
        fetchTransactions();
      } else {
        alert("Failed: " + result.error);
      }
    } catch (err) {
      console.error("Transaction Error:", err);
    }
  };

  return (
    <div className="container-fluid py-4 bg-light min-vh-100">
      <div className="row">
        {/* Sidebar */}
        <div className="col-lg-3 mb-4">
          <div className="card border-0 shadow-sm rounded-4">
            <div className="card-body text-center">
              <div className="mb-3">
                <div
                  className="rounded-circle bg-primary bg-opacity-10 d-inline-flex justify-content-center align-items-center"
                  style={{ width: 80, height: 80 }}
                >
                  <i className="bi bi-person fs-1 text-primary"></i>
                </div>
              </div>
              <h4 className="fw-semibold mb-0">{username}</h4>
              <p className="text-secondary small">@{username}</p>
              <hr />
              <p className="text-uppercase small text-muted mb-1">Wallet Balance</p>
              <h3 className="fw-bold text-primary">${balance.toFixed(2)}</h3>
            </div>

            <div className="list-group list-group-flush">
              <button
                className={`list-group-item list-group-item-action border-0 ${activeSection === "exchange" ? "active-section" : ""
                  }`}
                onClick={() => {
                  setActiveSection("exchange");
                  setShowExchangeModal(true);
                }}
              >
                💱 Exchange
              </button>
              <button
                className={`list-group-item list-group-item-action border-0 ${activeSection === "transactions" ? "active-section" : ""
                  }`}
                onClick={() => setActiveSection("transactions")}
              >
                📊 Transactions
              </button>
              <button
                className={`list-group-item list-group-item-action border-0 ${activeSection === "plan" ? "active-section" : ""
                  }`}
                onClick={() => setActiveSection("plan")}
              >
                📦 Plans
              </button>
            </div>
          </div>
        </div>

        {/* Right Content Area */}
        <div className="col-lg-9">
          {/* Transactions Section */}
          {activeSection === "transactions" && (
            <div className="card border-0 shadow-sm rounded-4 mb-4">
              <div className="card-header bg-white border-0 py-3 px-4">
                <h5 className="fw-semibold text-primary mb-0">Transaction History</h5>
              </div>
              <div className="card-body p-4">
                <table className="table table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>Details</th>
                      <th>Type</th>
                      <th>Amount</th>
                      <th>Status</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transactions.length === 0 ? (
                      <tr>
                        <td colSpan="5" className="text-center text-muted py-4">
                          No transactions found.
                        </td>
                      </tr>
                    ) : (
                      transactions.map((t) => (
                        <tr key={t.id}>
                          <td>
                            <div className="d-flex align-items-center">
                              <div
                                className={`rounded-circle d-flex justify-content-center align-items-center me-3 ${t.category === "Withdrawal"
                                  ? "bg-danger bg-opacity-10 text-danger"
                                  : t.category === "Bonus"
                                    ? "bg-info bg-opacity-10 text-info"
                                    : "bg-success bg-opacity-10 text-success"
                                  }`}
                                style={{ width: 40, height: 40 }}
                              >
                                <i
                                  className={`bi ${t.category === "Withdrawal"
                                    ? "bi-arrow-up-right"
                                    : "bi-arrow-down-left"
                                    } fs-5`}
                                ></i>
                              </div>
                              <div>
                                <strong>{t.type}</strong>
                                <br />
                                <small className="text-muted">{t.id}</small>
                              </div>
                            </div>
                          </td>
                          <td>{t.category}</td>
                          <td className="fw-semibold">{t.amount}</td>
                          <td>
                            <span
                              className={`badge rounded-pill ${t.status === "Approved"
                                ? "bg-success-subtle text-success border border-success-subtle"
                                : "bg-warning-subtle text-warning border border-warning-subtle"
                                } px-3 py-2`}
                            >
                              {t.status}
                            </span>
                          </td>
                          <td>{new Date(t.date).toLocaleString()}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Plans Section */}
          {activeSection === "plan" && (
            <div className="card border-0 shadow-sm rounded-4">
              <div className="card-header bg-white border-0 py-3 px-4">
                <h5 className="fw-semibold text-primary mb-0">User Packages</h5>
              </div>
              <div className="card-body p-4">
                <table className="table table-striped align-middle text-center">
                  <thead className="table-light">
                    <tr>
                      <th>Package Name</th>
                      <th>Price ($)</th>
                      <th>Profit/Like</th>
                      <th>Profit/View</th>
                      <th>Progress (%)</th>
                      <th>Status</th>
                      <th>Created At</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userPackages.length > 0 ? (
                      userPackages.map((pkg) => (
                        <tr key={pkg.transaction_id}>
                          <td className="text-start">{pkg.package_name}</td>
                          <td>${pkg.price}</td>
                          <td>${pkg.profit_like}</td>
                          <td>${pkg.profit_view}</td>
                          <td>{pkg.progress}%</td>
                          <td>
                            {parseInt(pkg.is_finished) === 1 ? (
                              <span className="badge bg-success">Finished</span>
                            ) : (
                              <span className="badge bg-warning text-dark">In Progress</span>
                            )}

                          </td>
                          <td>{new Date(pkg.created_at).toLocaleString()}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-muted text-center py-4">
                          No packages found for this user.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Exchange Modal */}
      {showExchangeModal && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.6)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg rounded-4">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title fw-semibold">💱 Exchange</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowExchangeModal(false)}
                ></button>
              </div>
              <div className="modal-body p-4">
                <ul className="nav nav-tabs mb-3">
                  {["deposit", "bonus", "withdraw", "buy"].map((tab) => (
                    <li className="nav-item" key={tab}>
                      <button
                        className={`nav-link ${exchangeTab === tab ? "active" : ""}`}
                        onClick={() => setExchangeTab(tab)}
                      >
                        {tab === "buy"
                          ? "Buy Package"
                          : tab.charAt(0).toUpperCase() + tab.slice(1)}
                      </button>
                    </li>
                  ))}
                </ul>

                {exchangeTab !== "buy" && (
                  <>
                    <div className="mb-3">
                      <label className="form-label fw-semibold">Amount</label>
                      <input
                        type="number"
                        className="form-control rounded-3"
                        placeholder={`Enter ${exchangeTab} amount`}
                        value={depositAmount}
                        onChange={(e) => setDepositAmount(e.target.value)}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-semibold">Description</label>
                      <input
                        type="text"
                        className="form-control rounded-3"
                        placeholder="Enter description"
                        value={depositDescription}
                        onChange={(e) => setDepositDescription(e.target.value)}
                      />
                    </div>
                  </>
                )}

                {exchangeTab === "buy" && (
                  <div className="p-2">
                    <div className="mb-3">
                      <label className="form-label fw-semibold">Select Package</label>
                      <select
                        className="form-select rounded-3"
                        value={selectedPackage}
                        onChange={(e) => setSelectedPackage(e.target.value)}
                      >
                        <option value="">-- Select Package --</option>
                        {packages.map((pkg) => (
                          <option key={pkg.id} value={pkg.id}>
                            {pkg.package_name} — ${pkg.price}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="text-end">
                      <button className="btn btn-success px-4" onClick={handleBuyPackage}>
                        Confirm Buy
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <div className="modal-footer border-0 p-3">
                <button className="btn btn-primary px-4" onClick={handleConfirm}>
                  Confirm
                </button>
                <button
                  className="btn btn-outline-secondary px-4"
                  onClick={() => setShowExchangeModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewUser;
